<template>
  <section class="dianjin-panel">
    <div class="left-panel">
      <ul class="tabs">
        <li
          class="tab"
          v-for="(item, index) in tabs"
          :key="item.type"
          :class="{ 'tab--active': activeTab === index }"
          @click="changeTab(index)"
        >
          {{ item.name }}
        </li>
      </ul>
      <div class="wrapper">
        <dian-jin-list
          :list="dianJinList"
          :showAuthor="showAuthorInfo"
          :end="pageEnd"
          @loadMore="getDianJinList"
        ></dian-jin-list>
      </div>
    </div>
    <div class="right-panel">
      <star-author-panel :type="3" :title="title"></star-author-panel>
    </div>
  </section>
</template>

<script>
import { getDianjinList } from '@/api/dianjin'
import StarAuthorPanel from '@/components/StarAuthorPanel/StarAuthorPanel'
import DianJinList from '@/components/DianJinList/DianJinList'

export default {
  name: 'DianJin',
  components: { StarAuthorPanel, DianJinList },
  data() {
    return {
      tabs: [
        { name: '大咖观点', channel: 1 },
        { name: '机构看盘', channel: 5 },
        { name: '强档', channel: 2 }
      ],
      activeTab: 0,
      showAuthorInfo: true,
      title: '点金明星',
      dianJinList: [],
      viewState: '',
      pageEnd: false
    }
  },
  computed: {},
  created() {
    this.getDianJinList()
  },
  methods: {
    changeTab(index) {
      this.activeTab = index
      this.viewState = ''

      this.getDianJinList()
    },
    async getDianJinList() {
      const data = await getDianjinList(
        {
          direction: this.viewState ? 2 : 0,
          channel: this.tabs[this.activeTab].channel
        },
        this.viewState
      )
      if (data) {
        if (data.result.code === 0) {
          this.viewState = data.result.viewState
          this.pageEnd = data.detail.end
          if (data.detail.list.length === 0) {
            this.pageEnd = true
            this.dianJinList = data.detail.list
          }
          if (data.detail.flush) {
            this.dianJinList = data.detail.list
          } else {
            this.dianJinList = this.dianJinList.concat(data.detail.list)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.tabs {
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  color: #262626;
  text-align: center;
  border-bottom: 1px solid #ebebeb;
  display: flex;

  .tab {
    width: 98px;
    cursor: pointer;
  }

  .tab--active {
    position: relative;
    color: #046bcc;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 34px;
      height: 4px;
      background-color: #046bcc;
    }
  }
}

.dianjin-panel {
  display: flex;
  margin-top: 30px;
}

.left-panel {
  flex: auto;
  display: flex;
  flex-direction: column;
}
.right-panel {
  padding-left: 40px;
}
</style>
